import { CatalogSchema } from '@entities/Catalog/module/types/catalogSchema';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { fetchGetAllSizes } from '../services/fetch-get-all-sizes';
import { fetchGetArchivedModels } from '../services/fetch-get-archived-models';
import { fetchGetModels } from '../services/fetch-get-models';
import { fetchGetProducts } from '../services/fetch-get-products';
import { fetchGetSparky } from '../services/fetch-get-sparky';

const initialState: CatalogSchema = {
  isFetching: false,
  pagination: {
    currentPage: 1,
    totalItems: 0,
    totalPages: 0,
  },
  isInitial: false,
  initProductList: null,
  initModelList: null,
  initSparkyList: null,
  initArchivedModels: null,
  allSizes: [],
};

export const catalogSlice = createSlice({
  name: 'catalog',
  initialState,
  reducers: {
    setIsInitial: (state, action: PayloadAction<boolean>) => {
      state.isInitial = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.catalog,
      };
    });
    builder.addCase(fetchGetProducts.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(fetchGetProducts.fulfilled, (state, action) => {
      if (action.payload) {
        state.initProductList = action.payload.data;
        state.pagination = action.payload.pagination;
        state.isInitial = true;
      }
      state.isFetching = false;
    });
    builder.addCase(fetchGetProducts.rejected, state => {
      state.isFetching = false;
      state.isInitial = false;
    });
    builder.addCase(fetchGetModels.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(fetchGetModels.fulfilled, (state, action) => {
      if (action.payload) {
        state.initModelList = action.payload.data;
        state.pagination = action.payload.pagination;
        state.isInitial = true;
      }
      state.isFetching = false;
    });
    builder.addCase(fetchGetModels.rejected, state => {
      state.isFetching = false;
      state.isInitial = false;
    });
    builder.addCase(fetchGetSparky.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(fetchGetSparky.fulfilled, (state, action) => {
      if (action.payload) {
        state.initSparkyList = action.payload.data;
        state.pagination = action.payload.pagination;
        state.isInitial = true;
      }
      state.isFetching = false;
    });
    builder.addCase(fetchGetSparky.rejected, state => {
      state.isFetching = false;
      state.isInitial = false;
    });
    builder.addCase(fetchGetArchivedModels.fulfilled, (state, action) => {
      if (action.payload) {
        state.initArchivedModels = action.payload.data;
        state.isInitial = true;
      }
      state.isFetching = false;
    });
    builder.addCase(fetchGetArchivedModels.rejected, state => {
      state.isFetching = false;
      state.isInitial = false;
    });
    builder.addCase(fetchGetAllSizes.fulfilled, (state, action) => {
      if (action.payload) {
        state.allSizes = action.payload;
      }
    });
  },
});

export const { actions: catalogActions } = catalogSlice;
